"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var amazon_config_store_type_script_client_1 = require("@amzn/amazon-config-store-type-script-client");
var I18nPreferencesACSConfigContext = /** @class */ (function () {
    function I18nPreferencesACSConfigContext(i18nCxFamily, i18nCxId, i18nCxProgram) {
        this._i18nCxFamily = i18nCxFamily;
        this._i18nCxId = i18nCxId;
        this._i18nCxProgram = i18nCxProgram;
    }
    I18nPreferencesACSConfigContext.prototype.toRawContext = function () {
        var context = new Map();
        context.set("i18n_cx_family", this._i18nCxFamily);
        context.set("i18n_cx_id", this._i18nCxId);
        context.set("i18n_cx_program", this._i18nCxProgram);
        return new amazon_config_store_type_script_client_1.QueryContext(context);
    };
    Object.defineProperty(I18nPreferencesACSConfigContext.prototype, "i18nCxFamily", {
        get: function () {
            return this._i18nCxFamily;
        },
        set: function (value) {
            this._i18nCxFamily = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(I18nPreferencesACSConfigContext.prototype, "i18nCxId", {
        get: function () {
            return this._i18nCxId;
        },
        set: function (value) {
            this._i18nCxId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(I18nPreferencesACSConfigContext.prototype, "i18nCxProgram", {
        get: function () {
            return this._i18nCxProgram;
        },
        set: function (value) {
            this._i18nCxProgram = value;
        },
        enumerable: false,
        configurable: true
    });
    return I18nPreferencesACSConfigContext;
}());
exports.default = I18nPreferencesACSConfigContext;
